export const isObjectRecord = (value: unknown): value is Record<string, unknown> =>
    typeof value === 'object' && value !== null;

export const getNestedValue = (source: unknown, path: string): unknown => {
    if (!path) return undefined;

    return path.split('.').reduce<unknown>((currentValue, segment) => {
        if (!isObjectRecord(currentValue)) return undefined;
        return currentValue[segment];
    }, source);
};
